import { fetchData } from '../Api';

export const getCashBackSaldoPorPessoa = async (pessoaId) => {
  if (!pessoaId) return null;
  return await fetchData('/CashBack/SaldoPessoa', { pessoaId });
};

export const getCashBackMovimentosPorPessoa = async (pessoaId) => {
  if (!pessoaId) return [];
  return await fetchData('/CashBack/MovimentosPessoa', { pessoaId });
};
